/* eslint-disable import/prefer-default-export */
export const PAGES = {
  TRIPS: 'trips',
  DETAILS: 'details',
  CONTACT: 'contact',
  PASSWORD: 'password',
  AGREEMENT: 'agreement',
  REDIRECT: 'redirect',
} as const;
